import getBasePath from '../functions/api-resource';

const basePath = getBasePath('api', 'orcamento-tipo-investimento');

const tipoInvestimentoActions = {
  ativos: { method: 'GET', url: `${basePath}/ativos` },
};

export default (resource) => resource(`${basePath}`, {}, tipoInvestimentoActions);
